import axiosInstance from '../Lib/axios';
import {
  GET_NITIFICATION_PREFERENCE_LIST,
  GET_NITIFICATION_PREFERENCE_LIST_FAILED,
  GET_DOG_LIST,
  GET_DOG_LIST_FAILED,
  GET_LOGIN_USER_DETAILS,
  GET_LOGIN_USER_DETAILS_FAILED,
  UPDATE_DOG,
  UPDATE_DOG_FAILED,
  ADD_DOG,
  ADD_DOG_FAILED,
  GET_SERVICE_ORDER_LIST,
  GET_SERVICE_ORDER_LIST_FAILED,
  DELETE_DOG,
  DELETE_DOG_FAILED,
  UPDATE_USER_DETAILS,
  UPDATE_USER_DETAILS_FAILED,
  UPDATE_NITIFICATION_PREFERENCE,
  UPDATE_NITIFICATION_PREFERENCE_FAILED,
  GET_MESSAGES_LIST,
  GET_MESSAGES_LIST_FAILED,
  CREATE_NEW_TICKET,
  CREATE_NEW_TICKET_FAILED,
  MESSAGE_REPLAY,
  MESSAGE_REPLAY_FAILED,
  CLOSE_TICKET,
  CLOSE_TICKET_FAILED,
  GET_CARD_LIST,
  GET_CARD_LIST_FAILED,
  ADD_NEW_CARD_FAILED,
  ADD_NEW_CARD,
  DELETE_CARD,
  DELETE_CARD_FAILED,
  MESSAGE_COUNT,
  MESSAGE_COUNT_FAILED,
  VIEW_SERVICE,
  VIEW_SERVICE_FAILED,
  PAUSE_SERVICE_FAILED,
  PAUSE_SERVICE,
  GET_PAUSE_SERVICE,
  GET_PAUSE_SERVICE_FAILED,
  DELETE_PAUSE_SERVICE,
  DELETE_PAUSE_SERVICE_FAILED,
  GET_PAST_UPCOMING_SERVICE,
  GET_PAST_UPCOMING_SERVICE_FAILED,
  ADD_REVIEW,
  ADD_REVIEW_FAILED,
  UPDATE_CARD,
  UPDATE_CARD_FAILED,
  ADD_BAG,
  ADD_BAG_FAILED,
  GET_ACCOUNT_LISTING_SUCCESSFULLY,
  GET_ACCOUNT_LISTING_FAILED,
  PRINT_INVOICE,
  PRINT_INVOICE_FAILED,
  SERVICE_STATS,
  SERVICE_STATS_FAILED,
  GET_INVOICE_CREDIT_MEMO_LIST,
  GET_INVOICE_CREDIT_MEMO_LIST_FAILED,
  GET_BILLING_INFO,
  GET_BILLING_INFO_FAILED,
  GET_REASON_LIST,
  GET_REASON_LIST_FAILED
} from './types';


////////Acount Info////////////
//Get login user details
export const getAccountInfo = (params) => {

  return (dispatch) => {
    return axiosInstance
      .get(`user/me/`,
      { params, })
      .then((response) => {
        dispatch({
          type: GET_LOGIN_USER_DETAILS,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_LOGIN_USER_DETAILS_FAILED,
              data: error.response.data,
            });
          }
        }


      });
  };
};
export const updateUser = (params) => {

  return (dispatch) => {
    return axiosInstance
      .patch(`user/me/`, params, {})
      .then((response) => {
        dispatch({
          type: UPDATE_USER_DETAILS,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: UPDATE_USER_DETAILS_FAILED,
              data: error.response.data,
            });
          }
        }


      });
  };
};


// Get notification-preference
export const getNotification = (params) => {

  return (dispatch) => {
    return axiosInstance
      .get(`notification-preference/`, { params, })
      .then((response) => {
        dispatch({
          type: GET_NITIFICATION_PREFERENCE_LIST,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_NITIFICATION_PREFERENCE_LIST_FAILED,
              data: error.response.data,
            });
          }
        }


      });
  };
};

export const updateNotification = (params) => {

  return (dispatch) => {
    return axiosInstance
      .patch(`notification-preference/`, params, {})
      .then((response) => {
        dispatch({
          type: UPDATE_NITIFICATION_PREFERENCE,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: UPDATE_NITIFICATION_PREFERENCE_FAILED,
              data: error.response.data,
            });
          }
        }


      });
  };
};


////////Dog Info////////////

// Add Dog
export const addPets = (params) => {
  return (dispatch) => {
    return axiosInstance.post(`pet/`, params)
      .then((response) => {
        dispatch({
          type: ADD_DOG,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: ADD_DOG_FAILED,
              data: error.response.data,
            });
          }
        }


      });
  };
};

// Get Dog List
export const getPets = (params) => {

  return (dispatch) => {
    return axiosInstance
      .get(`pet/`, { params, })
      .then((response) => {
        dispatch({
          type: GET_DOG_LIST,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_DOG_LIST_FAILED,
              data: error.response.data,
            });
          }
        }


      });
  };
};
// Add Dog List
export const UpdatePets = (params) => {

  return (dispatch) => {
    return axiosInstance.patch(`pet/${params.uuid}/`, params, {})
      .then((response) => {
        dispatch({
          type: UPDATE_DOG,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: UPDATE_DOG_FAILED,
              data: error.response.data,
            });
          }
        }


      });
  };
};

//Delete Dog
export const deletePets = (uuid) => {

  return (dispatch) => {
    return axiosInstance.delete(`pet/${uuid}/`, {})
      .then(() => {
        dispatch({
          type: DELETE_DOG,
          data: { 'message': 'deleted' },
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: DELETE_DOG_FAILED,
              data: error.response.data,
            });
          }
        }


      });
  };
};
// get address from service order



/////Messages
// Get Unread message count
export const getMessagesCount = (params) => {

  return (dispatch) => {
    return axiosInstance
      .get(`/message/unread-count/`, { params, })
      .then((response) => {
        dispatch({
          type: MESSAGE_COUNT,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: MESSAGE_COUNT_FAILED,
              data: error.response.data,
            });
          }
        }


      });
  };
};

// Messsages module start here
export const getMessagesList = (params) => {

  return (dispatch) => {
    return axiosInstance
      .get(`/message/`, { params, })
      .then((response) => {
        dispatch({
          type: GET_MESSAGES_LIST,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_MESSAGES_LIST_FAILED,
              data: error.response.data,
            });
          }
        }


      });
  };
};

export const getCSVData = (params) => {

  return () => {
    return axiosInstance
      .get(`/message/`, { params, })
      .then((response) => {

        let data = response.data;
        var blob = new Blob([data], { type: 'application/CSV' });

        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'messages.csv';
        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }

        }


      });
  };
};

// Create New ticket
export const createMessage = (params) => {

  return (dispatch) => {
    return axiosInstance.post(`/message/`, params)
      .then((response) => {
        dispatch({
          type: CREATE_NEW_TICKET,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: CREATE_NEW_TICKET_FAILED,
              data: error.response.data,
            });
          }
        }


      });
  };
};
// Message replay
export const messageReplay = (params) => {

  return (dispatch) => {
    return axiosInstance.post(`/message-reply/`, params)
      .then((response) => {
        dispatch({
          type: MESSAGE_REPLAY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: MESSAGE_REPLAY_FAILED,
              data: error.response.data,
            });
          }
        }


      });
  };
};

//close ticket
export const closeTicket = (params) => {

  return (dispatch) => {
    return axiosInstance.patch(`message/${params.uuid}/`, params, {})
      .then((response) => {
        dispatch({
          type: CLOSE_TICKET,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: CLOSE_TICKET_FAILED,
              data: error.response.data,
            });
          }
        }


      });
  };
};


////Billing info

// get Card list
export const getCardList = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/user-billing-info/`, { params, })
      .then((response) => {
        dispatch({
          type: GET_CARD_LIST,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_CARD_LIST_FAILED,
              data: error.response.data,
            });
          }
        }


      });
  };
};

export const createCustomerInstax = async (data) => {
  try {
    const res = await axiosInstance.post(`crm/create-customer-in-stax`, data);
    return res.data.id;
  } catch (error) {
    console.log(error);
  }
};

//Add new Card
export const addNewCard = (params) => {
  return (dispatch) => {
    return axiosInstance.post(`/user-billing-info/`, params)
      .then((response) => {
        dispatch({
          type: ADD_NEW_CARD,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: ADD_NEW_CARD_FAILED,
              data: error.response.data,
            });
          }
        }


      });
  };
};


// Update Card
export const UpdateCard = (params) => {
  return (dispatch) => {
    return axiosInstance.patch(`/user-billing-info/${params.uuid}/`, { ...params })
      .then((response) => {
        dispatch({
          type: UPDATE_CARD,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: UPDATE_CARD_FAILED,
              data: error.response.data,
            });
          }
        }


      });
  };
};

// delete Card list
export const deleteCard = (uuid) => {
  return (dispatch) => {
    return axiosInstance.delete(`/user-billing-info/${uuid}/`, {data: {location: 'website'}})
      .then((response) => {
        dispatch({
          type: DELETE_CARD,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: DELETE_CARD_FAILED,
              data: error.response.data,
            });
          }
        }


      });
  };
};

///////Billing info
export const getBillingInfo = (user_id) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/user-billing-info/get_user_billing_tab/?user__uuid=${user_id}`, )
      .then((response) => {
        dispatch({
          type: GET_BILLING_INFO,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_BILLING_INFO_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

///////Service
export const getServiceOrder = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/service-order/`, { params })
      .then((response) => {
        dispatch({
          type: GET_SERVICE_ORDER_LIST,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_SERVICE_ORDER_LIST_FAILED,
              data: error.response.data,
            });
          }
        }


      });
  };
};

//View My service
export const ViewService = (params) => {

  return (dispatch) => {
    return axiosInstance
      .get(`/service/`, { params })
      .then((response) => {
        dispatch({
          type: VIEW_SERVICE,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: VIEW_SERVICE_FAILED,
              data: error.response.data,
            });
          }
        }


      });
  };
};

//Pause service
export const pauseService = (params) => {

  return (dispatch) => {
    return axiosInstance.post(`/service-pause/`, params)
      .then((response) => {
        dispatch({
          type: PAUSE_SERVICE,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: PAUSE_SERVICE_FAILED,
              data: error.response.data,
            });
          }
        }


      });
  };
};

//Get Pause service
export const getPauseService = (params) => {

  return (dispatch) => {
    return axiosInstance.get(`/service-pause/`, { params })
      .then((response) => {
        dispatch({
          type: GET_PAUSE_SERVICE,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_PAUSE_SERVICE_FAILED,
              data: error.response.data,
            });
          }
        }


      });
  };
};



//Add Bag
export const addServiceBag = (params) => {

  return (dispatch) => {
    return axiosInstance.post(`/service/add_bags/`, params, {})
      .then((response) => {
        dispatch({
          type: ADD_BAG,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: ADD_BAG_FAILED,
              data: error.response.data,
            });
          }
        }


      });
  };
};

//Delete Pause service
export const deletePauseService = (uuid) => {

  return (dispatch) => {
    return axiosInstance.delete(`/service-pause/${uuid}/`, {})
      .then(() => {
        dispatch({
          type: DELETE_PAUSE_SERVICE,
          data: { data: 'deleted' },
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: DELETE_PAUSE_SERVICE_FAILED,
              data: error.response.data,
            });
          }
        }


      });
  };
};

//Pause service
export const getPastUpcomingService = (params) => {

  return (dispatch) => {
    return axiosInstance.get(`/service/past_and_upcoming_services/`, { params })
      .then((response) => {
        dispatch({
          type: GET_PAST_UPCOMING_SERVICE,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_PAST_UPCOMING_SERVICE_FAILED,
              data: error.response.data,
            });
          }
        }


      });
  };
};

// add Feedback

export const addReviewInService = (params) => {

  return (dispatch) => {
    return axiosInstance.patch(`/service/${params.uuid}/`, params, {})
      .then((response) => {
        dispatch({
          type: ADD_REVIEW,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: ADD_REVIEW_FAILED,
              data: error.response.data,
            });
          }
        }


      });
  };
};



//Invoice

// Get all Invoice
export const getAccountListing = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/invoice/`, { params })
      .then((response) => {
        dispatch({
          type: GET_ACCOUNT_LISTING_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_ACCOUNT_LISTING_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Get all Invoice-Credit Memo 
export const getInvoiceCreditMemoList = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/credit-memo/get_credit_memo_and_invoice/`, { params })
      .then((response) => {
        dispatch({
          type: GET_INVOICE_CREDIT_MEMO_LIST,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_INVOICE_CREDIT_MEMO_LIST_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Print Invoice
export const printInvoice = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/invoice/print-invoices/`, { params })
      .then((response) => {
        dispatch({
          type: PRINT_INVOICE,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: PRINT_INVOICE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Print Invoice
export const getServiceStats = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/service/latest_service_stats/`, { params })
      .then((response) => {
        dispatch({
          type: SERVICE_STATS,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: SERVICE_STATS_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Get Reason List
export const getReasonList = (params) => {

  return (dispatch) => {
    return axiosInstance
      .get(`/disposition-dropdown/`, { params, })
      .then((response) => {
        dispatch({
          type: GET_REASON_LIST,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_REASON_LIST_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};